import trialScreener from './trial-screener';
export default trialScreener;
